import React, { memo, useCallback, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./styles.scss";
import { useDispatch } from "react-redux";
import { setNavbarParams, setText } from "../../../store/navbar";
import {
  getStudentEndPoints,
  MustIncludedSidebarItems,
} from "../../../constants/sidebar";
import { setLinks, showLinks } from "../../../store/sidebar";
import {
  getConceptVideosOfSubject,
  getSingalClassroomData,
} from "../../../utils/classrooms";
import Loader from "../../../components/Loader";
import ActivityTabsHeader from "../../../components/StudentDashboard/ActivityTabsHeader/ActivityTabsHeader";
import { Accordion, Button } from "react-bootstrap";
import { convertSecondsIntoMinutesAndHours } from "../../../utils/formater";
import withSubscriptionCheckButton from "../../../components/Common/withSubscriptionCheckButton";
import BsClock from "../../../constants/icons/Bs/BsClock";
import MdCheckBox from "../../../constants/icons/Md/MdCheckBox";
import MdCheckBoxOutlineBlank from "../../../constants/icons/Md/MdCheckBoxOutlineBlank";
import FiChevronDown from "../../../constants/icons/Fi/FiChevronDown";
import FiChevronUp from "../../../constants/icons/Fi/FiChevronUp";
import LiaCheckDoubleSolid from "../../../constants/icons/Lia/LiaCheckDoubleSolid";
import { useSelector } from "react-redux";
import {
  getUserInformation,
  getUserPermission,
  getUserRole,
} from "../../../store/userRole";
import { extractModulesInMentionedOrder } from "../../../utils/validations";

const WatchButton = withSubscriptionCheckButton(Button, "Concept Videos");

const ConceptVideosList = ({ isMobileView, hasValidSubscription }) => {
  const [isLoading, setIsLoading] = useState(true);
  const roleOfTheUser = useSelector(getUserRole);
  const [classroomName, setClassroomName] = useState("");
  const [classroomLoader, setClassroomLoader] = useState(true);
  const { id: classroomId } = useParams();
  const [activeTab, setActiveTab] = useState("");
  const [tabsList, setTabsList] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [sectionsList, setSectionsList] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedMobileTopic, setSelectedMobileTopic] = useState([]);
  const [modules, setModules] = useState([]);

  const rolePermissions = useSelector(getUserPermission);
  const userInformation = useSelector(getUserInformation);
  const [createdBy, setCreatedBy] = useState("");

  const [topicsList, setTopicsList] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const isNotifyConfig = queryParams.get("notificationConfig");
  const notifySub = queryParams.get("subj");
  const notifySec = queryParams.get("sec");
  const notifyTopic = queryParams.get("topic");
  const notifyExam = queryParams.get("examId");
  const [focusedExam, setFocusExam] = useState("");

  const isFirstRef = useRef(false);

  useEffect(() => {
    if (
      isNotifyConfig &&
      isNotifyConfig === "true" &&
      isFirstRef.current === false &&
      sectionsList?.length
    ) {
      isFirstRef.current = true;
      setActiveTab(notifySub);
      setSelectedSections([notifySec]);
      if (isMobileView) {
        setSelectedMobileTopic([notifyTopic]);
      } else {
        setSelectedTopic(notifyTopic);
        scrollToTopic(notifyTopic);
      }
      setFocusExam(notifyExam);
      setTimeout(() => {
        setFocusExam("");
      }, [3000]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNotifyConfig, sectionsList]);

  const getClassroomDetails = async () => {
    try {
      setClassroomLoader(true);
      const response = await getSingalClassroomData(classroomId);
      if (response?.data?.classRoom) {
        if (response?.data?.classRoom?.name) {
          setClassroomName(response?.data?.classRoom?.name);
          setModules(response?.data?.classRoom?.modulesIncluded);
          setCreatedBy(response?.data?.classRoom?.createdBy);

          // Filter subjects to exclude hidden ones and map the remaining ones
          const subjects = response?.data?.classRoom?.course?.subjects
            .filter((subject) => !subject?.isHidden) // Exclude subjects where isHidden is true
            .map((subject) => {
              return {
                id: subject?._id,
                label: subject?.name,
              };
            });

          if (response?.data?.classRoom?.course?._id) {
            setCourseId(response?.data?.classRoom?.course?._id);
          }
          if (subjects?.length > 0) {
            const storedSub = localStorage.getItem("watchConVidBack");
            if (storedSub) {
              setActiveTab(storedSub);
              localStorage.removeItem("watchConVidBack");
            } else {
              setActiveTab(subjects[0].id);
            }
          }
          setTabsList(subjects || []);
        }
      }
      setClassroomLoader(false);
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
      // Handle error, show a message to the user, etc.
    }
  };

  useEffect(() => {
    getClassroomDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const heading = "student-dashboard";
    dispatch(setText(heading));
    dispatch(setNavbarParams(`Concept Videos | ${classroomName}`));
    const defaultItems = [
      ...getStudentEndPoints(
        classroomId,
        roleOfTheUser,
        userInformation?._id === createdBy,
        rolePermissions
      ),
    ];
    const sidebarItems = defaultItems.filter(
      (item) =>
        modules.includes(item?.value) ||
        MustIncludedSidebarItems.includes(item?.value)
    );
    const indOfItem = sidebarItems?.findIndex(
      (item) => item.value === "Concept Videos"
    );
    if (indOfItem !== -1) {
      sidebarItems[indOfItem].selected = true;
    }
    dispatch(setLinks(extractModulesInMentionedOrder(sidebarItems, modules)));
    dispatch(showLinks());
  }, [
    classroomId,
    classroomName,
    createdBy,
    dispatch,
    modules,
    roleOfTheUser,
    rolePermissions,
    userInformation?._id,
  ]);

  const getConceptVideosListOfSubject = async () => {
    try {
      setIsLoading(true);
      // Clear previous data immediately when fetching new data
      setTopicsList([]);
      setSectionsList([]);
      setSelectedTopic("");
      setSelectedMobileTopic([]);
      setSelectedSections([]);

      const response = await getConceptVideosOfSubject(
        classroomId,
        courseId,
        activeTab
      );
      if (response.ok && response?.data?.sections) {
        const sectionsWithVideos = response?.data?.sections
          .map((section) => ({
            ...section,
            topics: section.topics
              .filter((topic) => !topic.isHidden) // Exclude hidden topics
              .filter((topic) => topic.materials?.videos?.length > 0),
          }))
          .filter((section) => section.topics.length > 0); // Filter out sections with no topics with videos

        setSectionsList(sectionsWithVideos);

        if (sectionsWithVideos.length) {
          setSelectedSections([sectionsWithVideos[0]?._id]);
          if (
            sectionsWithVideos[0]?.topics &&
            sectionsWithVideos[0]?.topics?.length
          ) {
            setSelectedTopic(sectionsWithVideos[0]?.topics[0]?._id);
            setSelectedMobileTopic([sectionsWithVideos[0]?.topics[0]?._id]);
          }
          let topicArray = [];
          sectionsWithVideos.forEach((section) => {
            topicArray = [...topicArray, ...section?.topics];
          });
          setTopicsList(topicArray);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
      // Reset lists to empty if there's an error
      setTopicsList([]);
      setSectionsList([]);
      setSelectedTopic("");
      setSelectedMobileTopic([]);
      setSelectedSections([]);
      setIsLoading(false);
    }
  };

  const scrollToTopic = useCallback((topicId) => {
    const topicElement = document.getElementById(topicId);
    if (topicElement) {
      topicElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, []);

  // Add a new useEffect to clear data when activeTab changes
  useEffect(() => {
    // Clear data when activeTab changes
    if (activeTab !== "") {
      setTopicsList([]);
      setSectionsList([]);
      setSelectedTopic("");
      setSelectedMobileTopic([]);
      setSelectedSections([]);
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "" && courseId) {
      getConceptVideosListOfSubject();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, courseId]);

  function createArrayFromId(id) {
    return [id];
  }

  if (isLoading || classroomLoader) {
    return <Loader />;
  }

  return (
    <div>
      <div style={{ position: "sticky", top: "-1px", zIndex: 6 }}>
        <ActivityTabsHeader
          isMobileView={isMobileView}
          tabsList={tabsList}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
      <div className="row m-0">
        <div
          className="d-none d-lg-block col-4 scrollbarWidth"
          style={{
            position: "sticky",
            top: "67px",
            zIndex: 5,
            overflowY: "auto",
            maxHeight: "600px",
            marginTop: "15px",
            paddingLeft: "0px",
          }}
        >
          <div className="card p-0">
            {sectionsList?.length ? (
              sectionsList.map((section, index) => {
                const isSelected = selectedSections.some(
                  (selec) => selec === section?._id
                );
                const duration = convertSecondsIntoMinutesAndHours(
                  section?.duration
                );
                let displayTime = "";
                if (duration.hours > 0) {
                  displayTime += `${Math.ceil(duration.hours)}h `;
                }
                if (duration.minutes > 0) {
                  displayTime += `${Math.ceil(duration.minutes)}m `;
                }
                if (duration.seconds) {
                  displayTime += `${Math.ceil(duration.seconds)}s`;
                }
                if (
                  duration.hours === 0 &&
                  duration.minutes === 0 &&
                  duration.seconds === 0
                ) {
                  displayTime += "0s";
                }
                return (
                  <div key={index}>
                    <div
                      className="d-flex justify-content-between"
                      style={{
                        background: isSelected ? "#F5F7FA" : "white",
                        border: isSelected ? "1px solid #E9EAF0" : "",
                        padding: "20px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: 400,
                          lineHeight: "22px",
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          color: isSelected ? "#564FFD" : "#1D2026",
                        }}
                        onClick={() => {
                          if (isSelected) {
                            setSelectedSections(
                              selectedSections.filter(
                                (selec) => selec !== section?._id
                              )
                            );
                          } else {
                            setSelectedSections([
                              ...selectedSections,
                              section?._id,
                            ]);
                          }
                        }}
                      >
                        {isSelected ? (
                          <FiChevronUp
                            size={20}
                            style={{ marginRight: "8px", cursor: "pointer" }}
                          />
                        ) : (
                          <FiChevronDown
                            size={20}
                            style={{ marginRight: "8px", cursor: "pointer" }}
                          />
                        )}{" "}
                        {section?.name}
                      </div>
                      <div className="d-flex align-items-center">
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "22px",
                            textAlign: "left",
                            display: "flex",
                            alignItems: "center",
                            color: "#4E5566",
                            marginRight: "16px",
                          }}
                        >
                          <BsClock
                            color="#FD8E1F"
                            size={20}
                            style={{ marginRight: "8px" }}
                          />{" "}
                          {displayTime}
                        </div>
                        {window.innerWidth > 1024 && (
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "22px",
                              textAlign: "left",
                              display: "flex",
                              alignItems: "center",
                              color: "#4E5566",
                            }}
                          >
                            <LiaCheckDoubleSolid
                              color="#23BD33"
                              size={20}
                              style={{ marginRight: "8px" }}
                            />{" "}
                            {`${Math.ceil(section?.watchedPercentage)}% finish`}
                          </div>
                        )}
                      </div>
                    </div>
                    {isSelected ? (
                      section?.topics?.length ? (
                        <div className="py-2">
                          {section?.topics?.map((topic, index) => {
                            const isTopicSelected =
                              topic?._id === selectedTopic;
                            return (
                              <div
                                className="d-flex align-items-center concept-videos-topic"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  lineHeight: "22px",
                                  letterSpacing: "-0.01em",
                                  textAlign: "left",
                                  color: isTopicSelected
                                    ? "#1D2026"
                                    : "#4E5566",
                                  backgroundColor: isTopicSelected
                                    ? "#EBEBFF"
                                    : "",
                                  padding: "12px 20px 12px 20px",
                                }}
                                key={`top-${index}`}
                                onClick={() => {
                                  scrollToTopic(topic?._id);
                                  setSelectedTopic(topic?._id);
                                }}
                              >
                                {isTopicSelected ? (
                                  <MdCheckBox
                                    size={20}
                                    color="#564FFD"
                                    style={{ marginRight: "12px" }}
                                  />
                                ) : (
                                  <MdCheckBoxOutlineBlank
                                    size={20}
                                    color="#CED1D9"
                                    style={{ marginRight: "12px" }}
                                  />
                                )}
                                {`${index + 1}. ${topic?.name}`}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="p-4">
                          No topics present in this section.
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    <div style={{ border: "1px solid #E9EAF0" }} />
                  </div>
                );
              })
            ) : (
              <div className="p-4">No sections present in this subject.</div>
            )}
          </div>
        </div>
        <div className="d-none d-lg-block col-8" style={{ marginTop: "15px" }}>
          {topicsList.length ? (
            topicsList.map((topic, index) => {
              return (
                <div
                  key={`topic-index-${index}`}
                  id={topic?._id}
                  className="mb-4 d-flex align-items-center"
                >
                  <Accordion
                    className="categoriesAccordion w-100"
                    style={{
                      boxShadow:
                        selectedTopic === topic?._id
                          ? "0 0 6px rgba(35, 173, 278, 1)"
                          : "",
                    }}
                  >
                    <Accordion.Item className="bg-white">
                      <Accordion.Header>
                        <div className="d-flex flex-column bg-white p-2">
                          <strong style={{ fontSize: "16px" }}>
                            {topic?.name}
                          </strong>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className="p-0">
                        {topic?.materials?.videos?.length ? (
                          <div>
                            {topic?.materials?.videos.map((video, videoInd) => {
                              return (
                                <div
                                  key={videoInd}
                                  className="d-flex align-items-center justify-content-between px-4"
                                  style={{
                                    height: "60px",
                                    borderBottom: "1px solid #E1E1E1",
                                    background:
                                      video?._id === focusedExam
                                        ? "#e8e8e8"
                                        : "",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 400,
                                      lineHeight: "22px",
                                      letterSpacing: "-0.01em",
                                      textAlign: "left",
                                      color: "#1B2128",
                                    }}
                                  >
                                    {video?.heading}{" "}
                                  </div>
                                  <div>
                                    {classroomId !== "" &&
                                    roleOfTheUser === "Student" ? (
                                      <WatchButton
                                        onClick={() => {
                                          navigate(
                                            `/student/${classroomId}/watchvideos/${activeTab}?topic=${topic?._id}&video=${video?._id}`
                                          );
                                        }}
                                        classRoomId={classroomId}
                                        requiredFeature="Concept Videos"
                                        hasValidSubscription={
                                          hasValidSubscription
                                        }
                                        subjects={createArrayFromId(activeTab)}
                                        index={videoInd}
                                      >
                                        Watch
                                      </WatchButton>
                                    ) : (
                                      <Button
                                        onClick={() => {
                                          navigate(
                                            `/${classroomId}/watchvideos/${activeTab}?topic=${topic?._id}&video=${video?._id}`
                                          );
                                        }}
                                        className="start-classroom-styles"
                                        variant="outline-primary"
                                      >
                                        Watch
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <p
                            className="px-4 py-3"
                            style={{ color: "#6E7485", fontSize: "12px" }}
                          >
                            No concept videos found.
                          </p>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              );
            })
          ) : (
            <div className="card p-4 text-center">
              <p className="mb-0">
                No concept videos available for this subject.
              </p>
            </div>
          )}
        </div>
        <div
          className="d-block d-lg-none col-12"
          style={{
            marginTop: "15px",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div className="p-0 bg-white">
            {sectionsList?.length ? (
              sectionsList.map((section, index) => {
                const isSelected = selectedSections.some(
                  (selec) => selec === section?._id
                );
                return (
                  <div key={index}>
                    <div
                      className="d-flex justify-content-between"
                      style={{
                        background: "#F5F7FA",
                        border: "1px solid #E9EAF0",
                        padding: "20px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "22px",
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          color: "#564FFD",
                        }}
                        onClick={() => {
                          if (isSelected) {
                            setSelectedSections(
                              selectedSections.filter(
                                (selec) => selec !== section?._id
                              )
                            );
                          } else {
                            setSelectedSections([
                              ...selectedSections,
                              section?._id,
                            ]);
                          }
                        }}
                      >
                        {isSelected ? (
                          <FiChevronUp
                            size={20}
                            style={{ marginRight: "8px", cursor: "pointer" }}
                          />
                        ) : (
                          <FiChevronDown
                            size={20}
                            style={{ marginRight: "8px", cursor: "pointer" }}
                          />
                        )}{" "}
                        {section?.name}
                      </div>
                    </div>
                    {isSelected ? (
                      section?.topics?.length ? (
                        <div className="py-2">
                          {section?.topics?.map((topic, index) => {
                            const isTopicSelected = selectedMobileTopic.some(
                              (selec) => selec === topic?._id
                            );
                            return (
                              <>
                                <div
                                  className="d-flex align-items-center justify-content-between"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: 400,
                                    lineHeight: "22px",
                                    letterSpacing: "-0.01em",
                                    textAlign: "left",
                                    color: "#4E5566",
                                    padding: "12px 20px 12px 20px",
                                    border: "1px solid #F5F7FA",
                                  }}
                                  key={`top-${index}`}
                                  onClick={() => {
                                    if (isTopicSelected) {
                                      setSelectedMobileTopic(
                                        selectedMobileTopic.filter(
                                          (selec) => selec !== topic?._id
                                        )
                                      );
                                    } else {
                                      setSelectedMobileTopic([
                                        ...selectedMobileTopic,
                                        topic?._id,
                                      ]);
                                    }
                                  }}
                                >
                                  <div>{`${topic?.name}`}</div>
                                  <div>
                                    {isTopicSelected ? (
                                      <FiChevronUp size={20} />
                                    ) : (
                                      <FiChevronDown size={20} />
                                    )}
                                  </div>
                                </div>
                                {isTopicSelected ? (
                                  <>
                                    {topic?.materials?.videos?.length ? (
                                      <div>
                                        {topic?.materials?.videos.map(
                                          (video, videoInd) => {
                                            return (
                                              <div
                                                key={videoInd}
                                                className="d-flex align-items-center justify-content-between px-4"
                                                style={{
                                                  height: "60px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: "22px",
                                                    letterSpacing: "-0.01em",
                                                    textAlign: "left",
                                                    color: "#1B2128",
                                                  }}
                                                >
                                                  {video?.heading}{" "}
                                                </div>
                                                <div>
                                                  {classroomId !== "" &&
                                                  roleOfTheUser ===
                                                    "Student" ? (
                                                    <WatchButton
                                                      onClick={() => {
                                                        navigate(
                                                          `/student/${classroomId}/watchvideos/${activeTab}?topic=${topic?._id}&video=${video?._id}`
                                                        );
                                                      }}
                                                      classRoomId={classroomId}
                                                      requiredFeature="Concept Videos"
                                                      hasValidSubscription={
                                                        hasValidSubscription
                                                      }
                                                      subjects={createArrayFromId(
                                                        activeTab
                                                      )}
                                                      index={videoInd}
                                                    >
                                                      Watch
                                                    </WatchButton>
                                                  ) : (
                                                    <Button
                                                      onClick={() => {
                                                        navigate(
                                                          `/${classroomId}/watchvideos/${activeTab}?topic=${topic?._id}&video=${video?._id}`
                                                        );
                                                      }}
                                                      className="start-classroom-styles"
                                                      variant="outline-primary"
                                                    >
                                                      Watch
                                                    </Button>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    ) : (
                                      <p
                                        className="px-4 py-3"
                                        style={{
                                          color: "#6E7485",
                                          fontSize: "12px",
                                        }}
                                      >
                                        No concept videos found.
                                      </p>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="p-4">
                          No topics present in this section.
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    <div style={{ border: "1px solid #E9EAF0" }} />
                  </div>
                );
              })
            ) : (
              <div className="p-4 text-center">
                <p className="mb-0">
                  No concept videos available for this subject.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ConceptVideosList);
